export default {
  shared: {
    password: 'Contraseña',
    email: 'Correo electrónico',
  },
  session: {
    expired: 'Tu sesión ha caducado. Por favor, inicia sesión de nuevo.',
  },
  login: {
    title: 'Inicia Sesión Ahora',
    subtitle: 'Gestione sus paquetes turísticos, viajes al Camino y casos con facilidad.',
    brandingTitle: 'WAW BS',
    brandingSubtitle: 'Waw BS, simplificando las operaciones de viaje con tecnología inteligente.',
    orContinueWithEmail: 'O iniciar sesión con correo electrónico',
    logInGoogle: 'Inicia sesión con Google',
    logInApple: 'Inicia sesión con Apple',
    logInWithEmail: 'o Inicia sesión con tu correo electrónico',

    logIn: 'Iniciar sesión',
    forgot: 'He olvidado mi contraseña',
    redirect: 'Redirigiendo...',
    loginData: 'Datos de inicio de sesión',
    userNotAllowed: 'No existe un usuario con ese correo electrónico en la aplicación',
  },
  forgot: {
    recover: 'Restablecer contraseña',
    backLogin: 'Volver a inicio de sesión',
    receiveEmail: 'Recibirás un correo electrónico en esta dirección para restablecer tu contraseña.',
    receiveEmailSpam: 'Si no lo recibes, puede estar en tu carpeta de spam.',
    emailSent: 'Acabamos de reenviarte el correo electrónico, por favor verifica tu carpeta de spam.',
    resend: 'Reenviar',
    email: 'Ingresa tu dirección de correo electrónico',
  },
  reset: {
    addNewPassword: 'Agrega tu nueva contraseña',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirma tu nueva contraseña',
    congratulations: '¡Felicidades!',
    successfulRecover: 'Tu contraseña se ha restablecido correctamente. Ahora puedes iniciar sesión de nuevo y usar tus nuevas credenciales.',
    passwords: 'Contraseñas',
  },
};
